import SortableColumn from 'components/listing/sortable-column/sortable-column';
import { ShareholderDocumentsToGetAll } from 'model/shareholder-documents.model';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SortOrder } from 'services/sort';

interface ShareholderDocumentsTableHeaderProps {
    shareholderDocuments: ReadonlyArray<ShareholderDocumentsToGetAll>;
    handleSort: (property: ShareholderDocumentsSortProperties, order: SortOrder) => void;
    sortOrder: SortOrder;
    sortedProperty: ShareholderDocumentsSortProperties | undefined;
}

const I18N_PREFIX = 'shareholder-documents.table';

export type ShareholderDocumentsSortProperties = keyof Omit<ShareholderDocumentsToGetAll, 'issuerName' | 'description'> | 'shareholder.fund.name' | 'file.description';

const ShareholderDocumentsTableHeader = (props: ShareholderDocumentsTableHeaderProps) => {
    const { handleSort, shareholderDocuments, sortOrder, sortedProperty } = props;

    const { t } = useTranslation();

    const mapSortable = (_property: ShareholderDocumentsSortProperties) => {
        return {
            active: _property === sortedProperty,
            order: sortOrder,
            property: _property,
            isLoading: false,
            disabled: shareholderDocuments?.length <= 1,
            onSort: () => handleSort(_property, sortOrder)
        };
    };

    return (
        <tr className="page-container--table-head">
            <SortableColumn label={t(`${I18N_PREFIX}.issuer`)} sortable={mapSortable('shareholder.fund.name')} />
            <SortableColumn label={t(`${I18N_PREFIX}.documentDate`)} sortable={mapSortable('documentDate')} />
            <SortableColumn label={t(`${I18N_PREFIX}.calendarYear`)} sortable={mapSortable('calendarYear')} />
            <SortableColumn label={t(`${I18N_PREFIX}.description`)} sortable={mapSortable('file.description')} />
        </tr>
    );
};

export default ShareholderDocumentsTableHeader;
